import React from 'react'

import { LightThemeProvider } from '@qflow/theme'
import { PageContainer } from 'portal/pages/PageContainer'

import { ReportsLog } from 'portal/components/ReportsLog'
import { Sidebar } from 'portal/components/Sidebar'

export function Reports() {
  return (
    <LightThemeProvider>
      <Sidebar />

      <PageContainer>
        <ReportsLog />
      </PageContainer>
    </LightThemeProvider>
  )
}
